import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledModelsCarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static400};

  @media (min-width: ${Breakpoints.b1600}px) {
    gap: ${({ theme }) => theme.size.static450};
  }
`;
